<template>
  <div class="page-css">
    <h1>敏感个人信息收集处理知情同意书</h1>
    <p></p>
    <p>
      <b>重要提示：</b>&#8203;
      尊敬的用户，为保障您的个人信息权益，在您接受运动康复服务前，请仔细阅读本同意书。我们将遵循合法、正当、必要和诚信的原则，严格按照本同意书所述内容收集、处理您的个人信息。请您在充分理解后作出自主选择。
    </p>
    <p>
      为准确记录您的身体运动情况，本系统可能需要通过拍摄照片的方式，收集您的个人身体影像信息。此类影像属于您的个人敏感信息，我们将严格按照法律法规和以下条款进行处理：
    </p>
    <p>
      <b>目的与用途：</b
      >所拍摄影像将仅用于您的本次康复训练或体态评估。未经您的另行明确授权，不会用于其他目的。
    </p>
    <p>
      <b>信息安全：</b
      >我们将对影像进行严格保密，仅授权直接参与您康复的医护人员访问。影像将存储在安全的信息系统内，并采取技术保护措施。
    </p>
    <p>
      <b>您的权利：</b
      >您有权要求查阅、复制或要求删除为您拍摄的影像资料（法律法规要求必须留存的情况除外）。您也可以随时联系我们行使您的权利。
    </p>
    <p>
      <b>补充授权：</b
      >如果您同意将去标识化（即无法识别您个人身份）后的影像用于医学研究或教学，请在下方单独勾选授权。
    </p>
    <p></p>
    <p>
      <b
        >如您勾选“同意”代表您已阅读并理解上述全部内容，并授权我们以采集、识别、存储等方式处理您的敏感个人信息。</b
      >
    </p>
    <p class="blank_sapce"></p>
    <h1>用户协议</h1>
    <p></p>
    <p></p>
    <p>
      本《用户协议》（以下简称“本协议”）<b
        >由您（以下简称“用户”或“您”）与北京天星医疗股份有限公司（以下简称“本公司”或“我们”）共同签订。您一旦注册、登录、使用本服务或点击“同意”按钮，即表示您已充分阅读、理解并同意接受本协议的全部内容，并自愿遵守本协议及相关规则。本协议在您与系统间成立并发生法律效力，同时您成为本系统用户。在同意之前，请您再次确认已知悉并完全理解本协议的全部内容。如果您不同意本协议的任何内容，请立即停止使用本服务。</b
      >
    </p>
    <p></p>
    <p>一、 服务定义与确认</p>
    <p>
      1.1
      <b>运动康复系统（以下简称“本系统”）</b
      >是运动康复机器的患者康复咨询服务系统，通过本系统为您提供运动损伤、关节损伤的运动康复训练及测评等服务。我们的服务旨在帮助用户预防运动损伤、改善身体功能、进行关节术后康复训练指导等。
    </p>
    <p>
      1.2
      您知晓并同意，本系统提供的所有服务（包括但不限于咨询、评估、训练计划建议）均属于<b>健康咨询和运动指导范畴，而非医疗行为。本系统的服务不能替代医院的诊断、治疗或医嘱</b>。
    </p>
    <p>
      1.3
      根据国家法律法规变化及本系统运营需要，我们有权对本协议条款及相关规则不时地进行修改更新，修改更新后的内容一旦以任何形式公布在本系统上即生效，并取代此前相关内容，您应不时关注本系统公告、提示信息及协议、规则等相关内容的变动。您知悉并确认，如您不同意更新后的内容，应立即停止使用本系统；如您继续使用本系统，即视为知悉变动内容并同意接受。
    </p>
    <p>二、 用户资格与账号管理</p>
    <p>
      2.1
      您确认，在您开始注册程序并使用本系统服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。
    </p>
    <p>
      2.2
      <i class="emph-ub"
        >我们的服务仅限18周岁以上的用户使用，如果您未满18周岁，请您立刻停止使用我们的服务</i
      >；您应明确了解，若我们在服务过程中发现或怀疑您未满18周岁的，则我们可以随时中止或终止向您提供服务，直至您向我们提供已满18周岁的证明，或协助我们获得您的监护人的明示同意。
    </p>
    <p>
      2.3
      根据中国现行法律法规及规范性文件的规定，并出于履行与您之间的服务协议的需要，您有义务提供真实、准确、完整、合法的注册信息，并负责及时更新。如因您提供的信息不实或过时，导致我们无法为您提供或继续提供服务，由此产生的后果由您自行承担。
    </p>
    <p>
      2.3在符合账户使用规则的前提下，您将获得该账户的使用权，您同意我们享有根据经营需要及业务规范回收运动康复系统用户账户的权利。届时，您将不能再通过该账户登录本系统或使用相关服务。
    </p>
    <p>
      2.4
      我们有权按照相关法律法规及服务准则限制、冻结或终止您对运动康复系统账户的使用，由此给您带来的损失（包括但不限于通信中断，用户资料及相关数据等的清空等）由您自行承担。
    </p>
    <p>
      2.5
      如果您使用我们提供的服务，您应负责维护账号的保密性并限制第三方使用/访问您的计算机或移动设备，并确保您的登录密码未向任何第三方透露。您不得在未经我们许可的前提下有偿或无偿转让账户。并且，您同意对在您的账户和密码下发生的所有活动承担责任。
    </p>
    <p>三、 用户健康状况声明与承诺</p>
    <p>
      3.1
      <b>重大疾病告知：</b
      >您承诺，在接受我们的服务前，您已清楚知悉自身的健康状况。<b>如果您患有或被诊断出患有心脏病、高血压、脑血管疾病、严重骨质疏松、恶性肿瘤、孕期或产后特定阶段等任何不适宜进行运动的重大疾病或特殊情况，您必须在咨询前明确告知咨询师</b>。
    </p>
    <p>
      3.2
      <b>如实告知义务：</b
      >在咨询过程中，您有义务如实、完整地向咨询师描述您的身体状况、伤病史、疼痛感受、运动经历等信息。您理解，任何信息的隐瞒或虚假陈述都可能导致咨询师做出错误的判断，从而可能对您造成伤害。
    </p>
    <p>
      3.3
      <b>遵循医嘱：</b
      >如果您目前正在接受医疗治疗或持有医生的诊断证明与医嘱，您承诺已就参与运动康复咨询事宜征得您的医生同意。您理解，咨询师提供的建议不应与您的医嘱相冲突。
    </p>
    <p>四、 免责声明</p>
    <p>
      4.1
      <b>运动风险自知：</b
      >您完全理解并认可，任何体育活动都存在固有的受伤风险，包括但不限于肌肉拉伤、关节扭伤等。您自愿参与本系统指导的运动康复活动，并<b>独立承担所有可能发生的风险</b>。
    </p>
    <p>
      4.2
      <b>医疗判断：</b
      >您理解本系统的服务是指导性的，咨询师给出的建议<b>不能完全被视为医疗诊断、处方或治疗方案</b>。对于任何健康问题，最终诊断和治疗必须由线下医院执业医师进行。
    </p>
    <p>
      4.3 责任限制：在法律允许的范围内，<b
        >本系统及我们的咨询师对因以下情形造成的任何直接、间接、附带、特殊或后果性的损失或损害不承担责任：</b
      >
    </p>
    <ul class="bullet-list">
      <li>您隐瞒健康状况或未如实告知信息；</li>
      <li>您未遵循咨询师的明确指导或安全警告；</li>
      <li>您未在出现不适时及时停止训练并就医；</li>
      <li>您将运动建议用于诊断或治疗疾病；</li>
      <li>任何不可抗力事件导致的服务中断或数据丢失。</li>
    </ul>
    <p>五、 服务内容与使用规则</p>
    <p>
      5.1
      您有权在遵守本协议的前提下，通过本系统预约咨询、获取个性化的运动康复建议和训练计划。
    </p>
    <p>
      5.2
      您理解并同意，咨询师基于您提供的信息给出的建议是专业的、方向性的指导。<b>训练计划的最终执行效果取决于您的个体差异、执行程度、营养、休息等多种因素，本系统不对训练结果做出任何保证</b>。
    </p>
    <p>
      5.3
      <b
        >在执行训练计划过程中，如出现剧烈疼痛、眩晕、胸闷、呼吸困难等任何身体不适，您必须立即停止训练，并及时就医</b
      >。您应始终将自身安全置于首位。
    </p>
    <p>5.4 您不得将咨询师提供的训练计划分享、出售或用于任何商业目的。</p>
    <p>
      5.5
      关于系统软件的更新：为了改善用户体验、完善服务内容，公司将不断努力开发新的服务。
    </p>
    <p>5.6 除非法律允许或公司书面许可，您使用本系统过程中不得从事下列行为：</p>
    <p>（1）删除本系统及其副本上关于著作权的信息；</p>
    <p>
      （2）对本系统进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本系统的源代码；
    </p>
    <p>
      （3）对公司拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；
    </p>
    <p>
      （4）对本系统或者本系统运行过程中释放到任何终端内存中的数据、网站运行过程中客户端与服务器端的交互数据，以及本系统运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经公司授权的第三方工具／服务接入本系统和相关系统；
    </p>
    <p>
      （5）通过修改或伪造网站运行中的指令、数据，增加、删减、变动网站的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；
    </p>
    <p>
      （6）通过非公司开发、授权的第三方软件、插件、外挂、系统，登录或使用本系统及服务，或制作、发布、传播上述工具；
    </p>
    <p>
      （7）自行或者授权他人、第三方软件对本系统及其组件、模块、数据进行干扰。
    </p>
    <p>5.7 您同意严格遵守法律法规规章规定，依法遵守以下义务：</p>
    <p>
      （1）不得制作、传输或发表以下违法信息资料：反对宪法所确定的基本原则，煽动抗拒、破坏宪法和法律法规实施的；危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的，煽动推翻社会主义制度的；损害国家荣誉和利益的；歪曲、丑化、亵渎、否定英雄烈士事迹和精神，侵害英雄烈士的姓名、肖像、名誉、荣誉的；宣扬或煽动实施恐怖主义、极端主义及其活动的；煽动民族仇恨、民族歧视、破坏民族团结的言论；破坏国家宗教政策，宣扬邪教和封建迷信的；散布谣言，扰乱经济秩序和社会秩序的；散布淫秽、色情、暴力或者教唆犯罪的；侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的；法律、行政法规禁止的其他内容。
    </p>
    <p>
      （2）防范和抵制制作、复制、发布含有下列内容的不良信息资料：标题严重夸张，发表内容与标题严重不符的；不当评述自然灾害、重大事故等灾难的；煽动人群歧视、地域歧视等的；宣扬低俗、庸俗、媚俗内容的；违反社会公德行为的；侵犯未成年人合法权益的；其他对网络生态造成不良影响的内容。
    </p>
    <p>5.8 本协议依据国家相关法律法规规章制定，您亦同意严格遵守以下义务：</p>
    <p>（1）从境外向中国大陆传输资料信息时必须符合中国有关法规；</p>
    <p>
      （2）不得利用本系统从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；
    </p>
    <p>（3）不得干扰本系统的正常运转，不得侵入本应用及国家计算机信息系统；</p>
    <p>
      （4）不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的、不文明的等信息资料；
    </p>
    <p>（5）不得教唆他人从事违法违规或本协议、平合规则所禁止的行为；</p>
    <p>（6）不得利用在本系统注册的账户进行牟利性经营活动；</p>
    <p>
      （7）不得发布任何侵犯他人个人信息、著作权、商标权等知识产权或合法权利的内容。
    </p>
    <p>六、服务支付</p>
    <p>
      6.1
      您通过医院购买本系统的服务时，您应具备实施相关行为的权利能力和行为能力，如果您在18周岁以下，您需要在监护人的监护参与下才能注册并使用本系统。如果实施本应用场景下的任何操作行为，即视为您满足上述条件，并对您在订单中提供的所有信息的真实性负责。
    </p>
    <p>
      6.2在您适用本系统的服务时，请您仔细确认所选择的服务内容、服务方式、支付方式等信息。您的支付行为和意思表示视为您的行为和意思表示，您应对其行为及意思表示的法律后果承担连带责任。
    </p>
    <p>七、 知识产权</p>
    <p>
      7.1本系统的一切知识产权，以及与本软件相关的所有信息内容，包括但不限于：文字表述及其组合、图标、图饰、图像、图表、色彩、界面设计、版面框架、有关数据、附加程序、印刷材料或电子文档等均为北京天星医疗股份有限公司所有，受商标法、专利法、著作权法和国际著作权条约以及其他知识产权法律法规的保护。
    </p>
    <p>
      7.2
      未经我们或相关权利人明确书面授权，您不得复制、修改、出租、出售、传播或创建任何衍生作品。
    </p>
    <p>
      7.3本协议未明示授权的其他一切权利归我们所有，用户使用其他权利时必须获得我们的书面同意。
    </p>
    <p>八、 隐私保护</p>
    <p>
      8.1
      我们非常重视您的隐私。关于我们如何收集、使用、共享和保护您的个人信息，请详细阅读我们的
      <b>《隐私政策》</b>。该政策是本协议不可分割的一部分。
    </p>
    <p>九、违约责任</p>
    <p>
      9.1如果公司发现或收到他人举报投诉您违反本协议约定或存在任何恶意行为的，公司有权不经通知随时对相关内容进行删除、屏蔽，并视行为情节对违规帐号处以包括但不限于警告、限制或禁止使用部分或全部功能、帐号封禁、注销等处罚，并公告处理结果。
    </p>
    <p>
      9.2公司有权依据合理判断对违反有关法律法规或本协议规定的行为采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，您应独自承担由此而产生的一切法律责任。
    </p>
    <p>
      9.3您理解并同意，因您违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任；公司因此遭受损失的，您也应当一并赔偿。
    </p>
    <p>
      9.4
      除非另有明确的书面说明，公司不对本系统的运营及其包含在本系统上的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。
    </p>
    <p>十、服务的修改和终止</p>
    <p>
      10.1
      我们始终在不断更改和改进其所提供的服务。我们可能会增加或删除某项服务功能，也可能暂停或彻底停止某项服务。您可以随时停止使用我们的服务，我们也可能在法律法规或规范性标准允许的范围内随时停止向您提供服务，或随时对我们的服务增加或设置新的限制，但是，如果对您而言是更为严格的限制时，则我们会遵循法律法规或规范性标准的要求，向您发出合理的提前通知，并让您有机会备份和转移其留存在本服务中的信息。
    </p>
    <p>
      10.2
      您了解并同意，我们有权自主决定经营策略。在我们发生合并、分立、收购、资产转染时，我们可以向第三方转让本服务下相关资产；我们也可在单方面通知您后，将本协议下部分或全部服务转交由第三方运营或履行。具体受让主体以我们的通知为准。
    </p>
    <p>10.3 如您违反本协议中的行为规范的，我们有权随时终止向您提供所述服务。</p>
    <p>
      10.4
      在适用法律允许的最大范围内，对因使用或不能使用本软件所产生的间接性、偶然性及继发性损害风险，包括但不限于个人损害、商业赢利的丧失、贸易中断、商业信息的丢失或任何其它经济损失，我们不承担任何责任。
    </p>
    <p>
      10.5
      您理解并确认，我们需要定期或不定期地对我们的服务系统或相关的设备进行检修或者维护，如因此类情况而造成服务在合理时间内的中断，我们无需为此承担任何责任，但我们会事先进行通告。
    </p>
    <p>
      10.6
      我们不对您所发布或提供的信息数据的保存、修改、删除或储存失败负责，如因我们故意或过失导致除外。我们可以根据相关法律规定及服务的实际情况自行决定您在本服务终止后数据的最长储存期限，并在服务器上为其分配数据最大存储空间等。您可根据自己的需要自行备份本服务中的相关数据。您在此明确同意并接受，除非法律另有规定，如您停止使用本服务或本服务终止或您的小程序账户被回收的，我们可以从服务器上永久地删除您的全部数据。本服务终止后，我们没有义务向您返还任何数据。
    </p>
    <p>10.7 对于第三方原因造成的用户信息泄露，您应向第三方主张您的权利。</p>
    <p>十一、 法律适用与争议解决</p>
    <p>
      11.1
      本协议的订立、执行和解释及争议的解决均应适用中国法律。如双方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，应向协议签订地有管辖权的人民法院提起诉讼。本协议签订地为中华人民共和国北京市大兴区。
    </p>
    <p>
      11.2
      如果本协议中任何一条被视为废止、无效或因任何理由不可执行应视为并不影响任何其余条款的有效性和可执行性。
    </p>
    <p>
      11.3
      本协议未明示授权的其他权利由本公司保留，您在行使这些权利时须另外取得公司的书面许可。公司如果未行使前述任何权利，并不构成对该权利的放弃。
    </p>
    <p><b>协议生效时间：2026年2月9日</b></p>
    <p><b>运营主体名称：北京天星医疗股份有限公司</b></p>
    <p class="blank_sapce"></p>
    <h1>隐私政策</h1>
    <p></p>
    <p><b>协议生效时间：2026年2月9日</b></p>
    <p></p>
    <p>提示条款</p>
    <p></p>
    <p>
      运动康复系统是北京天星医疗股份有限公司（下称“天星医疗”或“我们”）致力于关节损伤患者术后康复训练的自主研创品牌。患者使用康复主机依据运动处方进行康复训练，训练过程中的关节角度、位移、训练姿态等通过康复功能软件进行量化的监测、评估和反馈；同时患者在康复主机端完成定期测评量表、体态评估并反馈上传到康复管理系统软件。
    </p>
    <p></p>
    <p>
      我们非常重视用户个人信息的保护，在您使用运动康复系统时，我们将按照本隐私政策收集、使用、存储及共享您的个人信息。我们将通过本隐私政策向您清晰地介绍，在您使用我们的产品或服务时，我们如何收集、使用、存储、共享您的个人信息以及为您提供访问、更新、删除和保护您个人信息的处理方式。
    </p>
    <p></p>
    <p>
      <b
        >为了给您提供相关的基本功能，我们尽量在最小必要范围内收集、使用您的个人信息（例如手机号、身体信息等）。由您提供或我们收集您的信息中，可能包含您的个人敏感信息，例如医疗信息，请您谨慎并留意个人敏感信息，您同意我们可以按照本隐私政策所述的目的和方式来处理您的个人敏感信息</b
      >。
    </p>
    <p></p>
    <p>
      <b
        >请您务必完整地阅读并理解本隐私政策，以帮助您了解维护自己隐私权的方式，特别是以粗体/下划线标识的条款，您应重点阅读，在确认充分理解并同意后再开始使用。在阅读完本隐私政策后，如您对本隐私政策或与本隐私政策相关的事宜有任何问题，您可以联系我们，我们会尽快为您作出解答</b
      >。
    </p>
    <p></p>
    <p>
      当您<i class="emph-ub">勾选同意</i
      >我们，我们才会合法使用和保护您的个人信息。您了解并同意在收集您的个人信息后，我们可能通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别您的身份，在此情况下我们有权使用已经去标识化的信息，而无需另行获得您的同意。
    </p>
    <p></p>
    <p>
      当您使用或开启相关功能或使用服务时，为实现功能、服务所必需，我们会收集、使用相关信息。除非是为实现基本业务功能或根据法律法规要求所必需的必要信息，您均可以拒绝提供。我们将在本隐私政策中逐项说明哪些是必要信息。
    </p>
    <p></p>
    <p><b>本隐私政策将帮助您了解以下内容</b></p>
    <p><b>一、定义</b></p>
    <p><b>二、我们如何收集和使用您的信息</b></p>
    <p><b>三、我们如何共享、公开披露、委托处理您的信息</b></p>
    <p><b>四、我们如何储存和保护您的信息</b></p>
    <p><b>五、您如何管理您的个人信息</b></p>
    <p><b>六、本隐私政策如何更新</b></p>
    <p><b>七、如何联系我们</b></p>
    <p></p>
    <p>一、定义</p>
    <p>（一）关联公司：北京天星医疗股份有限公司及子分公司。</p>
    <p>
      （二）个人信息：个人信息是以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。
    </p>
    <p>
      （三）敏感个人信息：是指一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息。（我们将在本隐私政策中对具体个人敏感信息以粗体/下划线进行显著标识）。
    </p>
    <p>二、我们如何收集和使用个人信息</p>
    <p>
      我们会按照如下方式收集您在使用服务时主动提供的，以及通过自动化手段收集您在使用功能或接受服务过程中产生的信息：
    </p>
    <p>（一）账号注册和登录</p>
    <p>
      当您注册、登录运动康复系统时，您可以通过手机号创建帐号，收集这些信息是为了帮助您完成注册。
    </p>
    <p>
      使用限制：1）手机号定义：长度为11，为纯数字，不能为空。2）短信验证码：4位数字组合。
    </p>
    <p></p>
    <p></p>
    <p>（二）康复训练</p>
    <p>
      当您在康复主机前根据运动处方中的视频指导进行康复训练，训练过程中，设备通过摄像头采集患者视频数据，利用人工智能（AI）算法动态捕捉训练动作并实时反馈，并采用深度学习算法对训练动作实时纠正和指导，训练完成后，可显示运动情况及排名。
    </p>
    <p>（三）康复测评</p>
    <p>
      当您点击主界面中的康复测评，进入康复测评界面，按照提示做规定动作，设备通过相机获取患者在三维空间的姿态信息，计算得到关节活动度测量结果，点击【下一步】，进入肌力等级评估，依据MRC分级评定标准进行肌力评定，患者按个人感受选择肌力等级，确认后进入疼痛等级评估，依据疼痛标准评定视觉模拟量表（VAS）进行疼痛等级评定，患者按照个人感受选择疼痛等级，确认后得到评定结果。
    </p>
    <p>（四）体态评估</p>
    <p>
      当您点击主界面中的体态评估，根据视频指示站立位拍照片，照片确定完成后，根据您在站立位下的三维人体姿态信息计算出量化的体态评估结果。患者可通过手机扫描二维码，查看、下载体态评估报告。体态评估报告中会收集您的<i
        class="emph-ub"
        >姓名、性别、年龄、身高、体重、电话、身体检测信息</i
      >
    </p>
    <p>（五）健康课堂</p>
    <p>对康复管理、康复知识、常见禁忌等进行科普性普及。</p>
    <p>（六）依法豁免征得同意收集和使用的个人信息</p>
    <p>
      请您理解，在下列情形中，根据法律法规及相关国家标准，我们收集和使用您的个人信息无需征得您的授权同意：
    </p>
    <p>1、与国家安全、国防安全有关的：</p>
    <p>2、与公共安全、公共卫生、重大公共利益有关的；</p>
    <p>3、与犯罪侦查、起诉、审判和判决执行等有关的；</p>
    <p>
      4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
    </p>
    <p>5、所收集的个人信息是个人信息主体自行向社会公众公开的；</p>
    <p>
      6、从合法公开披端的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等果道；
    </p>
    <p>7、根据您的要求签订合同所必需的；</p>
    <p>
      8、用于维护所提供的产品与或服务的安全稳定运行所必需的，例如发现、处置产品与或服务的故障；
    </p>
    <p>9、为合法的新闻报道所必需的；</p>
    <p>
      10、学术研究机构基于公共利益属于统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
    </p>
    <p>11、法律法规规定的其他情形。</p>
    <p>（七）收集、使用个人信息目的变更</p>
    <p>
      请您了解，随着我们业务的发展，可能会对运动康复系统的功能和提供的服务有所调整变化。原则上，当新功能或服务与我们当前提供的功能或服务相关时，收集与使用的个人信息将与原处理目的具有直接或合理关联。在与原处理目的无直接或合理关联的场景下，我们收集、使用您的个人信息，会再次进行告知，并征得您的同意。
    </p>
    <p>三、我们如何共享、公开披露、委托处理您的个人信息</p>
    <p>（一）共享</p>
    <p>
      除以下情形外，未经您同意，我们不会与天星医疗以外的公司、组织和个人共享您的个人信息：
    </p>
    <p>
      1、在法定情形下的共享：我们可能会根据法律法规规定、诉讼、争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息；
    </p>
    <p>2、为订立、履行您作为一方当事人的合同所必需的情况下的共享；</p>
    <p>
      3、与关联公司间共享：为便于我们与关联公司共同向您提供部分服务，或基于运动康复系统向您提供产品和服务，或为推荐您可能感兴趣的信息，或为识别会员账户异常，或为保护天星医疗及关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与我们的关联公司和／或其指定的服务提供商共享。我们会谨慎共享必要的个人信息，且受本政策中所声明目的的约束。请注意，我们在数据使用过程中严格遵守合法、正当且最小使用原则，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至敏感个人信息。请您更加谨慎地考虑并做出决定。
    </p>
    <p>4、应您的监护人合法要求而提供您的信息；</p>
    <p>
      5、根据与您签署的单项服务协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；
    </p>
    <p>6、基于符合法律法规的社会公共利益而提供。</p>
    <p>
      我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息。对我们与之共享个人信息的公司、组织和个人，数据相关接收方仅能接触到其履行职责所需信息，且我们将会通过相关协议要求其不得将数据信息用于其他超出约定范围的目的，并要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理信息。
    </p>
    <p>（二）公开披露</p>
    <p>
      我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，公开披露您的个人信息：
    </p>
    <p>1、获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；</p>
    <p>
      2、根据法律、法规的要求需要必须提供您信息的情况下，我们可能会依据所要求的信息类型和披露方式披露您的信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求接收方必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。
    </p>
    <p>（三）委托处理</p>
    <p>
      我们可能委托授权合作伙伴为您提供某些服务或代表我们履行职能。我们仅会出于本隐私政策声明的合法、正当、必要、特定、明确的目的委托其处理您的信息，授权合作伙伴只能接触到其履行职责所需信息，且不得将此信息用于其他任何目的。如果授权合作伙伴将您的信息用于我们未委托的用途，其应征得您的单独同意。
    </p>
    <p>
      对于我们委托处理个人信息的公司、组织和个人，我们仅会出于本政策声明的合法、正当、必要、特定、明确的目的委托其处理您的信息，相关方只能接触到其履行职责所需信息，且我们将会通过协议要求其不得将此信息用于其他任何超出委托范围的目的。如果相关方将您的信息用于我们未委托的用途，其将单独征得您的同意。
    </p>
    <p>（四）共同处理</p>
    <p>
      对于共同处理个人信息的场景，我们会与合作方根据法律规定签署相关协议并约定各自的权利和义务，确保在使用相关个人信息的过程中遵守法律的相关规定、保护数据安全。
    </p>
    <p>（五）共享、公开披露、委托处理个人信息时事先征得授权同意的例外</p>
    <p>以下情形中，共享、公开披露您的个人信息无需事先征得您的授权同意：</p>
    <p>1、与国家安全、国防安全有关的；</p>
    <p>2、与公共安全、公共卫生、重大公共利益有关的；</p>
    <p>3、与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的；</p>
    <p>
      4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
    </p>
    <p>5、您自行向社会公众公开的个人信息；</p>
    <p>
      6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
    </p>
    <p>7、法律法规规定的其他情形。</p>
    <p>
      请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的共享、转让、公开披露无需另行向您通知并征得您的同意。
    </p>
    <p>四、我们如何储存和保护您的信息</p>
    <p>（一）储存</p>
    <p>1、存储地点</p>
    <p>
      我们依照法律法规的规定，将在境内运营过程中收集和产生的您的个人信息存储于中华人民共和国境内的可信服务器上。
    </p>
    <p>2、存储期限</p>
    <p>
      我们仅在为提供运动康复系统及服务之目的所必需的期间内脱敏保留您的个人信息。超出必要期限后，我们将对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。
    </p>
    <p>（二）保护</p>
    <p>
      1、我们非常重视您个人信息的安全，将努力采取合理的安全措施（包括技术方面和管理方面）来保护您的个人信息，防止您提供的个人信息被不当使用或未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄漏。
    </p>
    <p>
      2、我们会使用不低于行业同行的加密技术、匿名化处理及相关合理可行的手段保护您的个人信息，并使用安全保护机制防止您的个人信息遭到恶意攻击。
    </p>
    <p>
      3、我们会建立专门的信息安全部门、安全管理制度、数据安全流程保障您的个人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问您的个人信息，并适时对数据和技术进行安全审计。
    </p>
    <p>
      4、<i class="emph-ub"
        >尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。</i
      >
    </p>
    <p>
      5、<i class="emph-ub"
        >您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的帐号密码及相关个人信息透露给他人。</i
      >
    </p>
    <p>
      6、我们会制定应急处理预案，并在发生用户信息安全事件时立即启动应急预案，努力阻止这些安全事件的影响和后果扩大。一旦发生用户信息安全事件（泄露、丢失）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已经采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。我们将及时将事件相关情况以推送通知、邮件、信函、短信及相关形式告知您，难以逐一告知时，我们会采取合理、有效的方式发布公告。同时，我们还将按照相关监管部门要求，上报用户信息安全事件的处置情况。
    </p>
    <p>
      7、您一旦离开运动康复系统及相关服务，浏览或使用其他网站、服务及内容资源，我们将没有能力和直接义务保护您在运动康复系统及相关服务之外的软件、网站提交的任何个人信息，无论您登录、浏览或使用上述软件、网站是否基于运动康复系统的链接或引导。
    </p>
    <p>
      <b
        >8、如您发现自己的个人信息泄密，尤其是您的账户及密码发生泄露，请您立即通过本政策最下方“如何联系我们”，以便我们采取相应措施</b
      >。
    </p>
    <p>五、您如何管理您的个人信息</p>
    <p>
      您有权访问、更新、更正、删除您的个人信息或者注销您的账户，您可以通过以下方式访问及管理您的个人信息：
    </p>
    <p>（一）访问、更新和更正</p>
    <p>
      我们鼓励您更新和修改您的个人信息以使其更准确有效，您可在【设置】访问您的个人信息，并根据对应信息的管理方式自行完成或要求我们进行修改、补充。我们将采取适当的技术手段或提供提交申请的联系渠道，尽可能保证您可以访问、更新和更正自己的个人信息或使用运动康复系统服务时提供的其他信息。在访问、更新和更正前述信息时，我们可能会要求您进行身份验证，以保障信息安全。
    </p>
    <p>
      除法律法规另有规定，当您更新和更正您的个人信息或申请注销账号时，我们可能不会立即从备份系统中更新和更正相应的信息，但会在备份更新时更新和更正这些信息。
    </p>
    <p>（二）删除您的信息</p>
    <p>
      您可以通过本政策列明的方式与我们联系，请求删除您的部分信息。在以下情形中，您可以向我们提出删除个人信息的请求：
    </p>
    <p>1、如果我们处理个人信息的行为违反法律法规；</p>
    <p>2、如果我们收集、使用您的个人信息，却未征得您的同意；</p>
    <p>3、如果我们处理个人信息的行为违反了与您的约定；</p>
    <p>4、如果您不再使用我们的产品／服务，或您注销了账户；</p>
    <p>5、如果我们不再为您提供产品／服务。</p>
    <p>
      若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。
    </p>
    <p>
      当您或我们协助您删除相关信息后，因为适用的法律法规和安全技术，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并不会再对其进行进一步处理，直到备份可以清除或实现匿名。
    </p>
    <p>（三）注销</p>
    <p>
      当您申请注销账号后，我们将停止为您提供产品与/或服务，并根据您的要求，除法律法规另有规定外，我们将删除您的个人信息。收到您注销账户请求后，如需我们人工处理的，我们承诺在15个工作日内完成核查和处理。
    </p>
    <p>（四）改变您授权同意的范围</p>
    <p>
      您总是可以选择是否披露信息。有些信息是使用运动康复系统服务所必需的，但大多数其他信息的提供是由您决定的。
    </p>
    <p>
      您可以通过删除信息、关闭设备功能等方式改变您授权我们继续收集信息的范围或撤回您的授权。
    </p>
    <p>
      当您撤回授权后，我们无法继续为您提供撤回授权所对应的服务，也不再处理您相应的信息。但您撤回授权的决定，不会影响此前基于您的授权而开展的信息处理。需要您联系我们完成撤回个人信息授权。
    </p>
    <p>（五）响应您的上述请求</p>
    <p>
      如您在使用运动康复系统服务的过程中需要对个人信息进行紧急安全处理，可拨打010-67867985联系我们，为保障安全，您可能需要提供书面请求或以其他方式证明您的身份，我们将根据具体情况在15天内作出答复。
    </p>
    <p>
      对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定费用。对于与您的身份不直接关联的信息、无端重复的信息，或者需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者不切实际的请求，我们可能会予以拒绝。
    </p>
    <p>在下列情形中，按照法律法规要求，我们将无法响应您的请求：</p>
    <p>1、与国家安全、国防安全有关的；</p>
    <p>2、与公共安全、公共卫生、重大公共利益有关的；</p>
    <p>3、与犯罪侦查、起诉、审判和执行判决等有关的；</p>
    <p>4、有充分证据表明个人信息主体存在主观恶意或滥用权利的；</p>
    <p>5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>
    <p>
      6、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；
    </p>
    <p>7、涉及商业秘密的；</p>
    <p>8、法律法规规定的其他情形。</p>
    <p>六、本隐私政策如何更新</p>
    <p>
      （一）为了给您提供更好的服务，我们可能会根据产品或服务的更新情况及法律法规的相关要求适时修改本政策的条款，该等修改构成本政策的一部分。
    </p>
    <p>
      （二）如该等更新造成您在本政策下权利的实质减少或重大变更，我们将在本政策生效前通过网站公告、推送通知、弹窗提示或其他方式来通知您，如您仍然继续使用的，即表示您已充分阅读、理解并同意受经修订的本政策的约束。
    </p>
    <p>（三）本政策所指的重大变更包括但不限于：</p>
    <p>
      1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
    </p>
    <p>
      2、我们在控制权等方面发生重大变化。如并购重组等引起的信息控制者变更等；
    </p>
    <p>3、个人信息共享、转让或公开披露的主要对象发生变化；</p>
    <p>4、您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
    <p>5、我们负责处理个人信息安全的责任部门，联络方式及投诉渠道发生变化时；</p>
    <p>6、个人信息安全影响评估报告表明存在高风险。</p>
    <p>
      （四）我们的任何修改都会将您的满意度置于首位。我们鼓励您在每次使用运动康复系统服务时都查阅我们的隐私政策。
    </p>
    <p>
      （五）我们可能在必需时（例如当我们由于系统维护而暂停某一项服务时）发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。
    </p>
    <p>七、如何联系我们</p>
    <p>（一）您可以于工作日（8：30-17：30）通过以下方式与我们联系：</p>
    <p><b>电话：010-67867985</b></p>
    <p>地址：北京市北京经济技术开发区经海二路25号1幢A018、B018</p>
    <p>
      （二）我们设立了或个人信息保护专员，您可以通过发送邮件至legal@starsportmed.com的方式与其联系。
    </p>
    <p>
      （三）可以通过上述联系方式进行投诉、举报。需注意的是，我们可能不会回复与本隐私政策或您的个人信息使用/处理无关的问题。如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过以下外部途径寻求解决方案：<i
        class="emph-ub"
        >向被告住所地有管辖权的法院提起民事诉讼。</i
      >
    </p>
  </div>
</template>
<script>
export default {
  name: 'AgreeMent'
};
</script>
<style lang="scss" scoped>
.page-css {
  width: 100%;
  height: 100%;
  padding: 10px 12px;
  box-sizing: border-box;
  background: #fff;
  color: #333;
}

h1 {
  padding: 0.2rem 0;
  font-size: 0.46rem;
  font-weight: bold;
  text-align: center;
}

h2 {
  padding: 6px 0;
  font-size: 0.46rem;
  font-weight: 400;
}

h3 {
  padding: 6px 0;
  font-size: 0.46rem;
}

p {
  text-indent: 1.5em;
  font-size: 0.44rem;
  line-height: 1.6;
}

p.line {
  padding-left: 20px;
}

p.blank_sapce {
  height: 0.44rem;
}

.line-tow {
  padding-left: 40px;
}

i.emph-ub {
  font-style: normal;
  text-decoration: underline;
  font-weight: bold;
}

ul.bullet-list {
  padding-left: 1.5em;
  margin: 0.2rem 0;
  list-style: disc;
}

ul.bullet-list li {
  font-size: 0.44rem;
  line-height: 1.6;
}
</style>
